<template>
  <div>
    <Cascader :data="dist6" v-model="distValue" v-bind="$attrs" @on-change="change"
              :load-data="dist6.getChildren"></Cascader>
  </div>
</template>
<script>
  import {societyDict} from '@tubo/society-base'

  export default {
    model: {prop: 'value', event: 'change'},
    props: {
      value: String,
      dictName: String,
    },
    data() {
      return {
        dist6: [],
      }
    },
    computed: {
      distValue: {
        get() {
          return societyDict.distCascaderValue(this.value)
        },
        set(val) {
        }
      }
    },
    methods: {
      change(val) {
        this.$emit('change', val[val.length-1])
        this.$emit('on-change', val[val.length-1])
      }
    },
    created() {
      setTimeout(() => {
        if (this.dictName)
          societyDict.distCascader(this.dictName).then(payload => this.dist6 = payload)
        else
          societyDict.distCascader().then(payload => this.dist6 = payload)
      })
    }
  }
</script>